module.exports = __webpack_public_path__ + "img/content3-5.f33ea95d.webp";